export default __webpack_public_path__ + "static/media/buckinghammall.ee34256e.png";